import React, { useState, useEffect } from "react";
import { readProctorAvailability } from "../control/proctorAvailabilityData.js";
import Table from 'react-bootstrap/Table';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import { useNavigate } from 'react-router-dom';

function ProctorAvailabilityDashboard() {
  const [availability, setAvailability] = useState([]);
  const navigate = useNavigate();

  const getAvailability = async () => {
    const availabilityData = await readProctorAvailability();
    setAvailability(availabilityData);
  };

  useEffect(() => {
    getAvailability();
  }, []);

  const handleAddProctor = () => {
    navigate("/addproctor");
  };

  const handleEditProctor = () => {
    navigate("/editproctor");
  };

  const handleClose = () => {
    navigate("/"); // Navigates back to Dev Home
  };

  const dayOrder = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];

  return (
    <Container fluid className="bg-white p-4 shadow-sm rounded position-relative">

      {/* X Button in Top Right Corner */}
      <Button
        variant="light"
        className="position-absolute"
        style={{ top: "-10px", right: "10px", zIndex: 10, border: "1px solid #ccc", padding: "4px 8px" }}
        onClick={handleClose}
      >
        ✖
      </Button>

      <Row className="align-items-center mb-4">
        <Col><h2>Proctor Data</h2></Col>
        <Col className="d-flex flex-column flex-md-row justify-content-md-end gap-2">
          <Button variant="success" className="w-md-auto" onClick={handleAddProctor}>Add Proctor</Button>
          <Button variant="success" className="me-2" onClick={handleEditProctor}>Edit Proctor</Button>
        </Col>
      </Row>

      <Row>
        <Col>
          <Table striped bordered hover className="my-4 mx-auto">
            <thead>
            <tr>
              <th>Proctor Name</th>
              <th>Availability</th>
              <th>Location</th>
            </tr>
            </thead>
            <tbody>
            {availability.map((item) => (
              <tr key={item.id}>
                <td>{item.proctorLastName}, {item.proctorFirstName}</td>
                <td>
                  {dayOrder.map((day) => {
                    const times = item.availability[day];
                    if (times && times.selected) {
                      return (
                        <div key={day}>
                          {times.selected &&
                            <div>
                              {day}: {times.startTime} - {times.endTime}
                            </div>
                          }
                        </div>
                      );
                    }
                    return null;
                  })}
                </td>
                <td>{item.location}</td>
              </tr>
            ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </Container>
  );
}

export default ProctorAvailabilityDashboard;